const getTimezoneOffset = (date: Date): string =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()

export { getTimezoneOffset }
